import LeftLine1 from "./leftLine1";
import RightLine1 from "./rightLine1";


export default function FinalFooterLine1 (){
    return <div className="LINE_1">
    <div className="flex justify-start 9:justify-center gap-c18 mb-c14 ">
      <LeftLine1/>
      <RightLine1/>
    </div>
  </div>
}